import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import * as brands from "@fortawesome/free-brands-svg-icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { Divider, Flex, Text } from "../../components";
import { Images } from "../../assets";
import { useApp } from "../../hooks";
import { Tools } from "../../utils";
import { Link } from "react-router-dom";
import React from "react";

const Footer = () => {
  const { openingHours, bootstrap, logoUrl } = useApp();
  const contact = bootstrap?.contact || {};
  const meta = bootstrap?.meta || {};
  const restaurantName = Tools.asText(contact.restaurantName);
  const blurb = Tools.asText(meta.description);
  const phone = Tools.asText(contact.uanNumber);
  const whatsapp = Tools.asText(contact.whatsappNumber);
  const address = Tools.asText(contact.address);
  const developerName = Tools.asText(meta.developerName);
  const developerContact = Tools.asText(meta.developerContact);
  const infos = [
    restaurantName && { label: restaurantName },
    blurb && { label: blurb },
    whatsapp && { label: "Whatsapp", value: whatsapp },
    phone && { label: "Call", value: phone },
    address && { label: "Address", value: address },
  ].filter(Boolean) as { label: string; value?: string }[];

  return (
    <Flex
      vertical
      className="bg-primary p-[2rem] [&>a]:no-underline !pb-[14rem] md:!pb-[11rem] lg:!pb-[11rem]"
    >
      <Flex gap={"2rem"} justify="space-between" className="flex-column-mobile">
        <Flex gap={"2rem"} className="flex-column-mobile">
          <img
            src={Tools.mediaUrl(logoUrl) || Images.logo}
            className="h-[8rem] w-[8rem] object-contain"
            alt="logo"
          />
          <Flex
            vertical
            gap={".5rem"}
            children={React.Children.toArray(
              infos.map((info) => (
                <Text weight={700} type="tertiary">
                  {`${info.label} ${!!info.value ? ":" : ""} `}
                  {!!info.value && (
                    <Text
                      weight={400}
                      color="inherit"
                      level={"text"}
                      children={info.value}
                    />
                  )}
                </Text>
              )),
            )}
          />
        </Flex>
        <div>
          <div>
            <Text
              weight={700}
              type="tertiary"
              className="m-5-b"
              children={"Opening Timings"}
            />
            <Flex
              vertical
              gap={".3rem"}
              children={React.Children.toArray(
                (openingHours || []).map((openingHour) => (
                  <Flex gap={"8rem"} justify="space-between" align="center">
                    <Text
                      type="tertiary"
                      children={"• " + (openingHour.days?.join(", ") || "")}
                    />
                    <Text
                      type="tertiary"
                      children={`${Tools.formatTime(
                        openingHour.open,
                      )} - ${Tools.formatTime(openingHour.close)}`}
                    />
                  </Flex>
                )),
              )}
            />
          </div>
          <div className="m-20-t space-y-4">
            <Text weight={700} type="tertiary" children={"Follow Us"} />
            <Flex gap={"1rem"}>
              {React.Children.toArray(
                (bootstrap?.socials || []).map((social: any) => (
                  <a
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Text type="tertiary">
                      <FontAwesomeIcon
                        icon={
                          ((brands as Record<string, IconDefinition | unknown>)[
                            `fa${social.platform}`
                          ] || faGlobe) as IconDefinition
                        }
                        size="2x"
                      />
                    </Text>
                  </a>
                )),
              )}
            </Flex>
          </div>
          <Flex gap={"1.5rem"} className="m-20-t">
            <Link to="/terms">
              <Text type="tertiary" children="Terms" />
            </Link>
            <Link to="/privacy-policy">
              <Text type="tertiary" children="Privacy" />
            </Link>
            <Link to="/refund-policy">
              <Text type="tertiary" children="Refunds" />
            </Link>
          </Flex>
        </div>
      </Flex>
      {!!developerName && (
        <>
          <Divider className="m-20-t m-10-b !border-[rgba(255,255,255,0.35)]" />
          <Text
            align="center"
            type="tertiary"
            children={`Powered by ${developerName}${
              developerContact ? ` · ${developerContact}` : ""
            }`}
          />
        </>
      )}
    </Flex>
  );
};

export default Footer;
